module.exports = __webpack_public_path__ + "img/section2b_1.baaa28d1.png";